import styled from 'styled-components';
import { LAYERS, SIZE } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY, BUTTON_ACTION_HEIGHT } from 'common/constants';
import { Label } from 'common/baseComponents';
import { SearchInput } from 'components/SearchBox/styles';

export interface PickerProps {
    required?: boolean
}

export const PickerBase = styled.input`
    border-radius: 5px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px ${(props: PickerProps) => props.required ? `#ff7319` : `rgba(130, 130, 130, 0.5)`};
    background-color: #ffffff;
    position: relative;
    flex:unset;
    font-family: ${DEFAULT_FONT_FAMILY};
    margin: ${SIZE.TWO}px;
    margin-left: 0px;
    padding: ${SIZE.ONE_AND_A_HALF}px ${SIZE.ONE}px;
    height: ${SIZE.THREE}px;

    ::placeholder {
        margin: 0 4.7px 0 0;
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: rgba(112, 112, 112, 0.5);
    }
`

export const YearPicker = styled(PickerBase)`
    width: ${SIZE.THIRTEEN}px;
    margin-left: 0px;

    
`

export const MonthPicker = styled(PickerBase)`
    width: ${SIZE.THIRTEEN}px;
`

export const DayPicker = styled(PickerBase)`
    width: ${SIZE.THIRTEEN}px;
    
`

export const AlertText = styled.div`
  background-image: linear-gradient(to top, #f36868, #f66000);
  font-family: ${DEFAULT_FONT_FAMILY};
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: ${SIZE.ONE}px 0px;
`

export const DatePickerComponentContainer = styled.div`
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
    -moz-appearance: textfield;
    }
`

export const DatePickerContainer = styled.div`
    display: flex;

    position: relative;
    max-height: ${SIZE.TEN}px;
    width: ${SIZE.FIFTY}px;
`

export const DatePickerTitle = styled.div`
    width: ${SIZE.FORTY_TWO}px;
    height: ${SIZE.TWO}px;
    flex-grow: 0;
    margin: ${SIZE.FIVE}px ${SIZE.TWELVE}px 0 ${SIZE.THREE}px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    
`

export const DrawerContainer = styled.div`
    position: absolute;
    top: ${SIZE.NINE}px;

    width: ${SIZE.FIFTEEN}px;
    height: 434px;
    padding: 14px 0px 16px 0px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);

    z-index: ${LAYERS.LAYER_4};
    display: flex;
    flex-flow: column;
    
    max-height: ${SIZE.NINETEEN}px;
    background: white;

    border-radius: ${SIZE.HALF}px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: ${SIZE.ONE}px;

`

export const DrawerOptionsContainer = styled.div`
    background: white;
    display:flex;
    flex:1;
    overflow: auto;
`

export const DrawerList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: column;
    flex:1;
    overflow: auto;

    ${SearchInput} {
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
    }
`
export interface DrawerListItemProps {
    highlighted: boolean
}

export const DrawerListItem = styled.li`
    height: ${SIZE.FOUR}px;
    display:flex;
    // padding:${SIZE.ONE}px;
    align-items: center;
    &:hover {
        cursor: pointer;
    };
    background: ${(props: DrawerListItemProps) => props.highlighted ? '#DADADA' : 'none'};
`
export const DrawerItemLabel = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    overflow:hidden;
    white-space:nowrap;
    color: #373f53;
    // margin: 0 ${SIZE.HALF}px 0 ${SIZE.HALF}px;
`

export const MainContainer = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    border-radius: ${SIZE.HALF}px;
    width: ${SIZE.THIRTY_TWO}px;
    height: ${SIZE.TEN}px;
`;